import FacilitatorRecord from '@/components/facilitator/FacilitatorRecord.vue';
import PersonalProfile from '@/components/facilitator/PersonalProfile.vue';
import HUBStore from '@/store';
import HUBLog from '@/utils/logger';
import HUBValidation from '@/utils/validation';

/**
 * Personal pages
 */

const personalRouter = {
  routes: [
    {
      path: '/personal',
      component: PersonalProfile,
      children: [
        {
          path: '',
          redirect: { name: 'youthLearningRecord' },
        },
        {
          // TODO: stop using this key to track user records
          path: 'facilitator-training',
          name: 'trainingRecord',
          component: FacilitatorRecord,
        },
        {
          path: 'youth-learning',
          name: 'youthLearningRecord',
          component: FacilitatorRecord,
        },
        {
          path: 'adult-learning',
          name: 'adultLearningRecord',
          component: FacilitatorRecord,
        },
      ],
    },
  ],
};

personalRouter.routes.forEach((r) => {
  const route = r;
  route.props = true;
});

personalRouter.guard = async (to) => {
  // Not a profile page, go to next guard
  if (!HUBValidation.validateRoute(to.name, personalRouter.routes)) {
    return;
  }

  HUBStore.commit('setHUBSettingItems', {
    currentFunction: {
      key: 'profile',
      name: 'Profile',
    },
    levelUp: { name: 'dashboard' },
  });

  HUBLog.debug(`Access: ${to.path}`);
  throw new Error();
};

export default personalRouter;
